import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueMui, greyMui, orangeMui, rydeColors } from "@ryde/theme";

export const EntityPropertiesControlsStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "entity-properties-controls-styled",
  },
)`
  .entityPropertiesControls__toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    padding: 4px 16px 8px;
  }

  .entityPropertiesControls__buttons {
    display: inline-flex;
    gap: 4px;
  }

  .entityPropertiesControls__extra {
    min-width: 0;
  }

  .entityPropertiesControls__button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 26px;
    padding: 0;
    border: 1px solid ${greyMui._300};
    border-radius: 13px;
    background: ${rydeColors.white};
    color: ${greyMui._600};
    cursor: pointer;

    &:hover {
      background: ${greyMui._100};
      color: ${greyMui._800};
    }

    &:focus-visible {
      outline: 2px solid ${rydeColors.focusedControl};
      outline-offset: 2px;
    }

    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

export const EntityPropertiesStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "entity-properties-styled",
})`
  display: flex;
  flex-direction: column;
  padding: 8px 16px;
  gap: 8px;

  * {
    overflow: clip;
  }

  .entityProperty {
    width: 100%;
    display: grid;
    grid-template-columns: minmax(auto, 30%) 1fr;
    gap: 8px;

    &__sub {
      gap: 16px;
    }

    &--single-line {
      & > :not(.entityProperty__key),
      .entityProperty__changes > * {
        min-width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &__key {
      color: ${rydeColors.darkBlue};

      &--muted {
        color: ${greyMui._600};
        font-size: 12px;
      }
    }

    &__toggle-sign {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      margin-inline-start: 6px;
      border-radius: 50%;
      font-size: 14px;
      font-weight: 700;
      line-height: 1;
      vertical-align: middle;

      &--expand {
        color: ${blueMui._700};
        background: ${blueMui._50};
      }

      &--collapse {
        color: ${orangeMui._800};
        background: ${orangeMui._50};
      }
    }

    &__delta {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      flex-basis: 100%;
      font-size: 12px;
      color: ${rydeColors.grey};
    }

    &__delta-item {
      padding: 0 6px;
      border-radius: 8px;
      font-variant-numeric: tabular-nums;

      &--up {
        color: ${rydeColors.passOutOrange};
        background: ${rydeColors.redTimeEditBg};
      }

      &--down {
        color: ${rydeColors.green};
        background: ${rydeColors.blueTimeEditBg};
      }
    }

    &__chips {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 4px;
    }

    &__chip {
      padding: 0 6px;
      border-radius: 10px;
      color: ${rydeColors.grey};

      &--moved-from {
        color: ${rydeColors.red};
        background: ${rydeColors.redTimeEditBg};
        font-weight: 600;
      }

      &--moved-to {
        color: ${rydeColors.green};
        background: ${rydeColors.blueTimeEditBg};
        font-weight: 600;
      }

      &--added {
        color: ${rydeColors.green};
        font-weight: 600;
      }

      &--removed {
        color: ${rydeColors.red};
        text-decoration: line-through;
      }
    }

    &__chip-arrow {
      color: ${rydeColors.softGray};
    }

    &__order-caption {
      min-width: 12px;
      color: ${rydeColors.grey};
    }

    &__changes {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
    }

    &__old-value {
      color: ${rydeColors.red};
    }

    &__new-value {
      color: ${rydeColors.lightGreen};
    }

    &__removed-value {
      color: ${rydeColors.red};
      text-decoration: line-through;
    }

    &__items {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    &__items-row {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
    }

    &__items-label {
      color: ${rydeColors.grey};
    }

    &__items-order {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    &__item-label {
      padding: 0 16px;
      color: ${rydeColors.darkBlue};
      font-weight: 500;
    }
  }
`;
